module.exports = __webpack_public_path__ + "static/img/product01.2aaae52.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/product01.png
// module id = /mT+
// module chunks = 1